import { FC } from 'react';
import { Redirect, useParams } from 'react-router-dom';

export const MonthlyStatementRedirect: FC = () => {
  const { monthlyStatementId } = useParams<{ monthlyStatementId: string }>();

  return (
    <Redirect
      to={{
        pathname: '/reporting/monthly-statements/overview',
        search: `monthlyStatementId=${monthlyStatementId}&servicePeriodStart=`,
      }}
    />
  );
};
